import { render, staticRenderFns } from "./StepsForWizard.vue?vue&type=template&id=2b801572&"
import script from "./StepsForWizard.vue?vue&type=script&lang=js&"
export * from "./StepsForWizard.vue?vue&type=script&lang=js&"
import style0 from "./StepsForWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports